import { useParams } from "react-router-dom"

import { PointSelectListener } from "@l2r-front/l2r-common"
import { BASE_MAP_ID, POINT_MIN_BBOX_WIDTH } from "@l2r-front/l2r-map"

import { useRiskZoneCluster } from "../../hooks/queries/useRiskZoneClusters"

export function RiskZoneSelectListener() {

    const { riskZoneId } = useParams()
    const { data: riskZoneFeatureCollection } = useRiskZoneCluster(riskZoneId, { as_geojson: true })

    return <PointSelectListener mapId={BASE_MAP_ID} pointFeature={riskZoneFeatureCollection?.features?.[0]} minBbboxWidth={POINT_MIN_BBOX_WIDTH * 2} />
}
